import { generateState } from '../builder'

export default {
  formats: [],
  formatItem: {},
  ...generateState('getFormats'),
  ...generateState('getFormat'),
}
